import { ShopifyStoreDetails } from 'components/EMManagement/EMManagementId/EMManagementIdBody/ShopifyStoresList/ShopifyStoreDetails';
import { Page } from 'layouts/Page';

export const ShopifyStoreDetailsPage = () => {
	return (
		<Page title="Shopify Store Details – EAS Control Center">
			<ShopifyStoreDetails />
		</Page>
	);
};
